module.exports = __webpack_public_path__ + "assets/img/ygpt.564ddc68.png";